import { render, staticRenderFns } from "./HeaderSlot.vue?vue&type=template&id=7b0dd833&lang=pug&"
import script from "./HeaderSlot.ts?vue&type=script&lang=ts&"
export * from "./HeaderSlot.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports